import * as React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import useLiveData from 'hooks/useLiveData';
import { Box, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import theme from 'utils/theme';
import Image, { withArtDirection } from 'components/Image';

const ServiceHeader = props => {
	const data = useStaticQuery(graphql`
		query serviceHeaderContentProvider {
		  allDepartment(
			filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}, inListing: {eq: true}}
		  ) {
		    edges {
		      node {
		      	name
				description
		      	uri
		        headerImage
				mobileHeaderImage
		      }
		    }
		  }
		}
	`);
	const { response } = useLiveData({
		type: 'Department',
		method: 'all',
		staticData: data,
	});
	const service = response.data.filter(item => item.uri === props.uri).shift();
	if (!!service === false) return null;
	//if (!!service.headerImage === false) return null;
	const isSvg = service.headerImage && service.headerImage.includes('.svg');

	const style = {
		...(service.headerImage ? {
			position: 'relative',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundImage: `url('${process.env.CDN_DOMAIN||''}${service.headerImage}${isSvg ? '' : '?format=webp&quality=100&max-w=1920'}')`,
			// '&:after': {
			// 	content: '""',
			// 	position: 'absolute',
			// 	top: 0,
			// 	left: 0,
			// 	width: '100%',
			// 	height: '100%',
			// 	background: 'rgba(15, 35, 69, 0.80)',
			// 	zIndex: 5,
			// },
			...(service.mobileHeaderImage ? {
				[theme.breakpoints.down('laptop')]: {
					backgroundImage: `url('${process.env.CDN_DOMAIN||''}${service.mobileHeaderImage}${isSvg ? '' : '?format=webp&quality=100&max-w=1920'}')`,
				},
			} : {})
		} : {}),
	};
	const boxStyle = {
		position: 'relative',
		zIndex: 10,
		minHeight: '606px',
		display: 'flex',
		alignItems: 'flex-end',
		padding: '98px 0',
		[theme.breakpoints.down('laptop')]: {
			minHeight: '487px',
			padding: '55.55px 0',
		},
	};
	const headerStyle = {
		paddingBottom: '7px',
		[theme.breakpoints.down('laptop')]: {
			paddingBottom: '26px',
		}
	};

	const Wrapper = props => {
		if (service.headerImage) {
			return <Image {...props} />;
		}
		return <Box {...props} />;
	};
	return (
		<Wrapper src={withArtDirection(service.mobileHeaderImage ? service.mobileHeaderImage : service.headerImage, {
			[theme.breakpoints.between('sm', 'xl')]: service.headerImage,
		})} loading="eager" priority="high">
			<Box component={"section"} className={`pageheader ${!!service.headerImage !== false ? 'has-image' : ''}`} sx={style}>
				<Box sx={boxStyle}>
					<Container>
						<Grid container alignItems="center">
							<Grid size={{ xs: 12, md: 9, lg: 9 }}>
								<Typography sx={headerStyle} variant="h1" component={props.useH1 ? 'h1' : 'div'}>{service.name}</Typography>
								<Typography variant="body1Masthead" component="div">{service.description}</Typography>
							</Grid>
						</Grid>
					</Container>
				</Box>
			</Box>
		</Wrapper>
	)
}

export default ServiceHeader;